const ComplaintDetailType = {
    MOBULE_NUMBER : 'MOBILE',
    METER_READING : 'READING',
    METER : 'METER',
    PAYMENT_MODE : 'PAYMENTMODE',
    APPLICATION_NUMBER : 'APPLICATION',
}

export default ComplaintDetailType